/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ExcludedProfileResponse {
  id: string;
  candidate_id: string;
  full_name?: string | null;
  linkedin_url?: string | null;
  reason?: string | null;
  added_by?: string | null;
  created_at: string;
}
